import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container ">
            <div className="row ">
              <div className="col-sm-6  intro-text">
                <div className="thumbnail cardLogin">
                  <img src="img/inicio/nominaBE.svg" alt="..." />
                  {/*<h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                 Nómina electrónica
                </a>{" "}*/}
                  <div class="caption">
                    <a
                      href="http://starlap.co:82/Login.aspx"
                      className="btn btn-custom btn-lg page-scroll"
                    >
                      Acceder
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6  intro-text intro-text2">
                <div className="thumbnail cardLogin">
                  <img src="img/inicio/starlapN.svg" alt="..." />
                  <div class="caption">
                    <a
                      href="http://starlap.co:89/"
                      className="btn btn-custom btn-lg page-scroll"
                    >
                      Acceder
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
